"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Briefcase, Laptop, Users } from "lucide-react";
const targetGroups = [{
  title: "Freelancer & Selbstständige",
  text: "Der Küchentisch hat ausgedient. Hier trennst du Arbeit und Leben wieder sauber. Und triffst Menschen, die wissen, wie sich Selbstständigkeit anfühlt.",
  icon: Laptop
}, {
  title: "Remote oder Home-Office",
  text: "Dein Team sitzt woanders. Du sitzt hier. Mit schnellem Internet, Ruhe zum Arbeiten und einem Ort, der sich anfühlt wie Büro, nur besser.",
  icon: Briefcase
}, {
  title: "Kleine Teams & Gründer",
  text: "Ein eigenes Büro? Noch nicht. Aber ein Ort, an dem ihr zusammenarbeitet, Meetings haltet und wachst, ohne euch langfristig zu binden.",
  icon: Users
}];
export default function ForFreelancersRemoteWorkersAndTeams() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="für-freelancer-remote-worker-und-teams" className="w-full bg-[#EEEEEE] overflow-hidden ![padding:144px_0px_144px_0px]">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>

      {/* Header - Two Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16 md:mb-20">
        <div>
          <span className="text-sm font-semibold uppercase tracking-widest text-[#888888] mb-4 block">Zielgruppen</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
            <span className="text-[#141414]">Für Menschen, die</span><br />
            <span className="text-[#141414]">mehr wollen</span>{" "}
            <span className="text-[#888888]">als einen</span><br />
            <span className="text-[#888888]">Schreibtisch.</span>
          </h2>
        </div>
        <div className="flex items-end">
          <p className="text-lg text-[#555555] leading-relaxed">
            Egal ob allein oder im Team, Vollzeit oder zwei Tage die Woche, dein Arbeitsplatz sollte sich dir anpassen. Nicht umgekehrt.
          </p>
        </div>
      </div>

{/* Cards */}
<div className="grid grid-cols-1 md:grid-cols-3 gap-3">
  {targetGroups.map((group, i) => <div key={i} data-index={i} className="group rounded-2xl bg-white/60 backdrop-blur-sm p-10 transition-all duration-300 hover:bg-white hover:shadow-lg hover:-translate-y-1 cursor-default flex flex-col">
      <h3 className="text-2xl font-bold mb-4 text-[#141414] tracking-tight">
        {group.title}
      </h3>
      <p className="text-[15px] leading-relaxed text-[#555555] mb-12">
        {group.text}
      </p>
      <span className="inline-block self-start rounded-full bg-[#141414]/5 border border-[#141414]/10 px-4 py-2 text-sm font-medium text-[#555555] mt-auto">
        {group.title}
      </span>
    </div>)}
</div>
    </div>
  </div>
</section>;
}